import { Button } from "matsuri-ui"
import SearchIcon from "@mui/icons-material/Search"
import { SearchPopper } from "./SearchPopper"
import { usePopper } from "./usePopper"

export const SearchOperation = () => {
    const { anchorEl, open, openPopper, closePopper } = usePopper()

    return (
        <>
            <Button rounded icon={<SearchIcon />} onClick={openPopper} />
            <SearchPopper
                anchorEl={anchorEl}
                closePopper={closePopper}
                open={open}
            />
        </>
    )
}
